/**
 * @Author: zpc
 * @Description:
 * @DateTime: Created in 2021-11-17 09:47:06
 */

 import * as Vue from 'vue-tsx-support';
 import { Component, Prop } from 'vue-property-decorator';
 import 'vue-tsx-support/enable-check';
 import Modal from 'src/types/iview/Modal';
 import Button from 'src/types/iview/Button';
 import Input from 'src/types/iview/Input';
 import { Toast } from 'src/util/toast';
 import { modalFactory } from 'src/util/vueExtend';
 import DiskConfigApi, { DiskConfigDOI } from './api/diskConfigApi';
 import EnumOperates from 'src/enums/enumOperates';
 import { Integer } from 'src/types/base';
 import InputNumber from 'src/types/iview/InputNumber';
 import EntitySelect from 'src/components/SelectCustom/entitySelect';
 import EnumEntity from 'src/enums/enumEntity';
 import CommonSelect from 'src/components/SelectCustom/commonSelect';
 import EnumDiskBank from 'src/enums/enumDiskBank';
 import IconCustom from 'src/components/icon/iconCustom';
 import EnumCloud from 'src/enums/EnumCloud';
 import EnmuEzopenType from 'src/enums/enmuEzopenType';
 import EnmuVideoQuality from 'src/enums/enmuVideoQuality';
 import { DateTimeUtil} from 'src/util/dateTimeUtil';
 
 export namespace OperateDiskPushVOI {
     export interface PropsI {
         data?: DiskConfigDOI.RowDataI;
 
         saveSuccess?(): void;
 
         cancel?(): void;
     }
 
     export interface FormDataI {
         channel_total_count: Integer;
         device_id: Integer;
         nvr_user_id: Integer;
         type:Integer;  // 1萤石云  2乐橙云  3 本地监控
         deviceserial: string;
         channelNo:Integer;
         ezopen_type:Integer;
         quality:Integer;
         expireTime:Integer; //过期时间
         chanels:Array;
         datatime:any;
     }
 }
 
 @Component
 class OperateDiskPushModal extends Vue.Component<OperateDiskPushVOI.PropsI> {
     @Prop({
         type: Function,
     })
     cancel!: () => void;
 
     @Prop({
         type: Object,
     })
     data?: DiskConfigDOI.RowDataI
 
     @Prop({
         type: Function,
     })
     saveSuccess!: () => void;
 
     visible: boolean = false;
 
     loading: boolean = false;
 
     formData: OperateDiskPushVOI.FormDataI = {
        channel_total_count: null,
        device_id: null,
        nvr_user_id: null,
        type:null,  // 1萤石云  2乐橙云  3 本地监控
        deviceserial: "",
        channelNo: null,
        ezopen_type: null,
        quality: null,
        expireTime: 5, //过期时间
        chanels: [],
        datatime: [],
     };
     rules: any = {
        name: [{ required: true, message: '请输入名称', trigger: 'change' }],
     };
     chanels: Array = [];
 
     close() {
        this.cancel && this.cancel();
        this.closeModal();
     }
 
     closeModal() {
        this.visible = false;
        this.$emit('close', false);
     }
 
    async save() {
        if (!(await this.$validate('formValidate'))) {
            return;
        }
         let res;
         this.loading = true;
         if(this.formData.ezopen_type == 1){
            let params = {
                ...this.formData,
            };
         }else{
            let params = {
                ...this.formData,
                ...{"startTime": DateTimeUtil.formateDate(this.formData.datatime[0])},
                ...{"stopTime": DateTimeUtil.formateDate(this.formData.datatime[1])}
            };
         }
         debugger
         res = await DiskConfigApi.getAddress(params);
         this.loading = false;
         let { code } = res;
         if (code === 0) {
            Toast.success('开启直播成功');
            this.saveSuccess();
            this.closeModal();
        }
    }

    mounted() {
        this.formData = this.data!
    }

    render(h) {
        return (
            <Modal title={"开启直播"} width="800" v-model={this.visible} mask-closable={false} on-on-cancel={this.close}>
                 <i-form ref="formValidate" labelWidth={100} model={this.formData} rules={this.rules} style="width:80%">
                     <form-item label="通道号" prop="channelNo" required style="display: inline-block;width:45%" type="number">
                        <CommonSelect dataSource={this.formData.chanels} v-model={this.formData.channelNo}/>
                     </form-item>
                     <form-item label="播放类型" prop="ezopen_type"  required style="display: inline-block;width:45%" type="number">
                        <CommonSelect dataSource={EnmuEzopenType.getList()} v-model={this.formData.ezopen_type}  />
                     </form-item>
                     <form-item label="清晰度" prop="quality"  required style="display: inline-block;width:45%" type="number">
                        <CommonSelect dataSource={EnmuVideoQuality.getList()} v-model={this.formData.quality}  />
                     </form-item>
                     <form-item v-if={this.formData.type == 1} label="过期时间(分)" prop="expireTime" required style="display: inline-block;width:45%" type="number">
                     <InputNumber min={5} max={43200} precision={5} v-model={this.formData.expireTime}/>
                     </form-item>
                     <form-item label="回放时间" prop="datatime" style="display: inline-block;width:66%">
                        <Date-picker type="datetimerange" format="yyyy-MM-dd HH:mm" v-model={this.formData.datatime} value={this.formData.datatime} ></Date-picker>
                     </form-item>
                 </i-form>
                 <div slot="footer">
                    <Button type="primary" ghost on-click={this.close}>
                        取消
                    </Button>
                    <Button type="primary" on-click={this.save} loading={this.loading}>
                        开启直播
                    </Button>
                 </div>
            </Modal>
        );
    }
 }
 
 export default function alertOperateDiskPushModal(data?: DiskConfigDOI.RowDataI): Promise<boolean> {
     return new Promise((resolve, reject) => {
         modalFactory<OperateDiskPushVOI.PropsI>(OperateDiskPushModal)({
             data,
             saveSuccess() {
                 resolve(true);
             },
             cancel() {
                 resolve(false);
             },
         });
     });
 }
 